import fromUnixTime from 'date-fns/fromUnixTime';
import isToday from 'date-fns/isToday';
import subDays from 'date-fns/subDays';
import { getUnixStartOfDay } from 'helpers/DateHelper';

export const getLineChartFilters = filters => {
  if (!filters?.from || !filters?.to) return filters;

  const from = fromUnixTime(filters.from);
  const to = fromUnixTime(filters.to);

  if (!isToday(from) || !isToday(to)) return filters;

  return {
    ...filters,
    from: getUnixStartOfDay(subDays(to, 6)),
    groupBy: 'day',
  };
};
